import { useNavigate } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';
import { useTimezoneUtils } from '@/hooks/useTimezoneUtils';

interface CustomerJobsTableProps {
  jobs: any[];
}

export function CustomerJobsTable({ jobs }: CustomerJobsTableProps) {
  const navigate = useNavigate();
  const { formatDate } = useTimezoneUtils();

  const getStatusColor = (status: string) => {
    const colors: Record<string, string> = {
      scheduled: 'bg-info',
      in_progress: 'bg-warning',
      on_hold: 'bg-warning',
      completed: 'bg-success',
      cancelled: 'bg-destructive',
    };
    return colors[status] || 'bg-muted-foreground';
  };

  const getPaymentStatusColor = (status: string) => {
    const colors: Record<string, string> = {
      unpaid: 'bg-destructive',
      partially_paid: 'bg-warning',
      paid: 'bg-success',
    };
    return colors[status] || 'bg-muted-foreground';
  };

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Job Number</TableHead>
            <TableHead>Service Type</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Scheduled</TableHead>
            <TableHead>Revenue</TableHead>
            <TableHead>Payment</TableHead>
            <TableHead>Tech</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {jobs.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center text-muted-foreground">
                No jobs found
              </TableCell>
            </TableRow>
          ) : (
            jobs.map((job) => (
              <TableRow
                key={job.id}
                className="cursor-pointer hover:bg-muted/50"
                onClick={() => navigate(`/jobs/${job.id}`)}
              >
                <TableCell className="font-medium">{job.job_number}</TableCell>
                <TableCell>{job.service_types?.name || 'N/A'}</TableCell>
                <TableCell>
                  <Badge className={getStatusColor(job.status)}>
                    {job.status.replace('_', ' ')}
                  </Badge>
                </TableCell>
                <TableCell>
                  {job.scheduled_date ? formatDate(job.scheduled_date, 'MMM dd, yyyy') : 'N/A'}
                </TableCell>
                <TableCell>${job.invoice_total?.toFixed(2) || '0.00'}</TableCell>
                <TableCell>
                  <Badge className={getPaymentStatusColor(job.payment_status)}>
                    {job.payment_status.replace('_', ' ')}
                  </Badge>
                </TableCell>
                <TableCell>{job.techs?.name || 'N/A'}</TableCell>
                <TableCell className="text-right" onClick={(e) => e.stopPropagation()}>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => navigate(`/jobs/${job.id}`)}
                  >
                    <Eye className="h-4 w-4" />
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
